// extracted by mini-css-extract-plugin
export default {"header":"header-module___header___c154fb63","titleWithIcon":"header-module___titleWithIcon___d7a6b1b5"};